import type { AppEnvironment } from "./store";

export type DeploymentConfig = {
  ShowTestMode: boolean;
  TestApiUrl: string;
  ProductionApiUrl: string;
};

const browserOrigin = typeof window !== "undefined" ? window.location.origin : "http://127.0.0.1:4173";
const productionOrigin = /^https?:\/\/(127\.0\.0\.1|localhost)(:|\/|$)/i.test(browserOrigin)
  ? "http://127.0.0.1:4102"
  : browserOrigin;

let current: DeploymentConfig = {
  ShowTestMode: true,
  TestApiUrl: "http://127.0.0.1:4101",
  ProductionApiUrl: productionOrigin
};

export async function loadDeploymentConfig() {
  try {
    const response = await fetch("/deployment-config.json", { cache: "no-store" });
    if (!response.ok) return current;
    const value = await response.json() as Partial<DeploymentConfig>;
    current = {
      ShowTestMode: value.ShowTestMode !== false,
      TestApiUrl: String(value.TestApiUrl || current.TestApiUrl).replace(/\/$/, ""),
      ProductionApiUrl: String(value.ProductionApiUrl || current.ProductionApiUrl).replace(/\/$/, "")
    };
  } catch {
    // Local development keeps the safe loopback defaults.
  }
  return current;
}

export function deploymentConfig() { return current; }
export function apiUrl(environment: AppEnvironment) {
  if (/^https?:\/\/(127\.0\.0\.1|localhost)(:|\/|$)/i.test(browserOrigin)) {
    return environment === "test" ? "http://127.0.0.1:4101" : "http://127.0.0.1:4102";
  }
  return environment === "test" ? current.TestApiUrl : current.ProductionApiUrl;
}
